module.exports = __webpack_public_path__ + "6fa77f1e918b88daa8b4eda5f767d024.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folders_person_2x.png
// module id = 20
// module chunks = 0 1 2 3 4